var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "section",
            [_c("spinner-loader", { attrs: { loading: _vm.loading } })],
            1
          )
        : _c(
            "section",
            { staticClass: "content-container" },
            [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "search-header",
                      attrs: { "align-h": "center" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "my-1", attrs: { md: "6" } },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: { placeholder: _vm.$t("search") },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.discountCodeModal",
                                  modifiers: { discountCodeModal: true },
                                },
                              ],
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _vm._v(
                                "\n            New Discount Code\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c("b-table", {
                    ref: "modsTable",
                    staticClass: "modifier-table",
                    attrs: {
                      items: _vm.discountCodes,
                      fields: _vm.fields,
                      filter: _vm.filter,
                      hover: "",
                      striped: "",
                      fixed: "",
                    },
                    on: { "row-clicked": _vm.rowClicked },
                  })
                : _c(
                    "div",
                    { staticClass: "fixed-center" },
                    [_c("spinner-loader")],
                    1
                  ),
            ],
            1
          ),
      _vm._v(" "),
      _c("discount-code-modal", {
        ref: "discountCodeModal",
        on: { submit: _vm.submitDiscountCode, delete: _vm.deleteDiscountCode },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }